import React from "react";

import Content from "./Content";
import TableStats from "./TableStats";

const DashBoard: React.FC = () => (
  
    <Content />
  
);

export const TableStatistics: React.FC = () => (
  
    <TableStats />
  
);

export default DashBoard;
